import {getNestedValue} from "@Common/utils/arr-path";

export const createWarningsArray = async ({warningData, items, getSurfaceName, ccConfig, userData, assetSources}) => {
    let showTextWarnings = ccConfig.showTextWarnings ?? true;
    let showMissingImageWarnings = ccConfig.showMissingImageWarnings ?? true;

    let warningArr = [];

    let hadEmptyImageError  = false;
    let hadLowDpiImageError = false;
    let hadMissingLogoError = false;
    let hadMissingHeadshotError = false;

    // const sampleWarningData = [
    //     {
    //         "regionViolationState": 1,
    //         "textCropViolationState": 2,
    //         "shapeViolationState": 1,
    //         "type": "BoundedTextItem",
    //         "name": "field07",
    //         "surfaceName": "Back",
    //         "surfaceIndex": 1
    //     }
    // ];
    // console.log(JSON.stringify(warningData, null, 2));
    // console.log("warningData", warningData);

    // create warning message
    for(let key in warningData) {
        let name = warningData[key].name;
        let surface = warningData[key].surfaceIndex;
        let warningItem = items.find(item => { return item?._name == name && item?._parentContainer?.parentComponent?._name == warningData[key]?.surfaceName });
        name = getNestedValue(ccConfig.templateConfigurations, [getSurfaceName(surface), name, "label"]) || name;
        //ignore warnings from none visible fields
        if (warningItem?.visible && !warningItem?.visualizationPermissions?.noPrint && !warningItem?.visualizationPermissions?.noShow) {
            //check for different warning types
            if(!hadLowDpiImageError && warningData[key].qualityViolationState === 3) {
                hadLowDpiImageError = true;
                warningArr.push({message: "The quality of your image(s) is too low.", side: surface, selection: [{name: warningData[key].name}]});
            } else if(warningData[key].textCropViolationState > 1) {
                warningArr.push({message: "Your text has been cropped in the field " + name + '.', side: surface, selection: [{name: warningData[key].name}]});
            }
            //The following warnings are provided by CC, but we don't have reason to display them.
            /*
            else if(warningData[key].safetyLineViolationState > 1) {
                warningArr.push(name + ': safety line violation');
            } else if(warningData[key].regionViolationState > 1) {
                warningArr.push(name + ': region violation');
            }
            */
        }
    }
    //check if pictures are set
    let tempBinding = ccConfig['templateBindingData'];
    for (const key in items) {
        let userLevel = userData.sourceData.xd.userLevel ? userData.sourceData.xd.userLevel.userLevel : 0;
        let canEditHeadshot = userLevel <= 3 || (userLevel === 5 && userData.sourceData.xd.company.prefs.agentCanEditHeadshot === 1) || (userLevel === 4 && userData.sourceData.xd.company.prefs.officeCanEditHeadshot1 === 1);
        let canEditLogos = userLevel <= 3 || (userLevel === 5 && userData.sourceData.xd.company.prefs.agentCanEditLogos === 1) || (userLevel === 4 && userData.sourceData.xd.company.prefs.officeCanEditLogos === 1);
        let surface = items[key].parentContainer.parentComponent.name ? items[key].parentContainer.parentComponent.name : '';
        let surfaceIndex = 0;
        ccConfig.productDefinition.surfaces.forEach((s, i) => {
            if(s.name === surface) {
                surfaceIndex = i;
            }
        });
        if( (!canEditHeadshot || !canEditLogos) && items[key]?.visible && !items[key]?.visualizationPermissions?.noPrint && !items[key]?.visualizationPermissions?.noShow ) {
            //if we have headshots and can't edit headshots
            let imageTag = tempBinding[surface]?.[items[key].name]?.imageTag;
            if ( imageTag === "headshot1" && !canEditHeadshot && !hadMissingHeadshotError ) {
                let empty = true;
                items[key].allowedTabs.forEach((asset) => {
                    if (asset !== "Image Gallery" && assetSources[asset]?.['rootCategory']) {
                        if(assetSources[asset]['rootCategory']['assets'].length !== 0) {
                            empty = false;
                        }
                    }
                });
                if (empty) {
                    warningArr.push({message: "No headshot available for your account. Please work with your admin to have a headshot added to your account."});
                    hadMissingHeadshotError = true;
                } else if(items[key].isEmptyContent) {
                    warningArr.push({message: "No headshot selected. Please open Edit mode and select a headshot.", side: surfaceIndex, selection: [{name: items[key].name}]});
                    hadMissingHeadshotError = true;
                }
                //same for logos
            } else if ( imageTag === "logo" && !canEditLogos && !hadMissingLogoError) {
                let empty = true;
                items[key].allowedTabs.forEach((asset) => {
                    if(asset !== "Image Gallery" && assetSources[asset]?.['rootCategory']) {
                        if(assetSources[asset]['rootCategory']['assets'].length !== 0) {
                            empty = false;
                        }
                    }
                });
                if (empty) {
                    warningArr.push({message: "Your logo gallery is empty. Please work with your admin to have logos added to your gallery."});
                    hadMissingLogoError = true;
                } else if(items[key].isEmptyContent) {
                    warningArr.push({message: "None selected. Click here to select a logo for this position.", side: surfaceIndex, selection: [{name: items[key].name}]});
                    hadMissingLogoError = true;
                }
            }
        }

        let itemSurface;
        let isRequired = false;
        try{
            itemSurface = items[key].parentContainer.parentComponent.name;
            let itemName = items[key].name;
            isRequired = ccConfig.templateConfigurations[itemSurface][itemName] && ccConfig.templateConfigurations[itemSurface][itemName].isRequired;
        }
        catch (e) {
            isRequired = false;
        }
        if(items[key].type === "PlaceholderItem"
            && items[key].name !== ""
            && items[key].content === null
            && showMissingImageWarnings
            && items[key]?.visible
            && items[key]?.visualizationPermissions?.noPrint === false
            && items[key]?.visualizationPermissions?.noShow === false
            && !hadEmptyImageError) {
            hadEmptyImageError = true;
            warningArr.push({message: "Some of your images are missing.", side: surfaceIndex, selection: [{name: items[key].name}]});
        }
        else if( (items[key].type === "BoundedTextItem" || items[key].type === "PathBoundedTextItem")
            && items[key]._locked === false
            && items[key].text === ""
            && showTextWarnings
            && isRequired) {
            let name = items[key].name;
            name = getNestedValue(ccConfig.templateConfigurations, [itemSurface, name, "label"]) || name;
            warningArr.push({message: "There is no text in the field " + name + '.', side: surfaceIndex, selection: [{name: items[key].name}]});
        }
    }

    return warningArr;
};
